import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';
import { NewInvite } from 'types/organization/invites';

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useSubmitInvites = (organizationId: string, callbacks?: Callbacks) => {
  const inviteStudentsService = useServices().inviteStudentsService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (invites: NewInvite[]) => inviteStudentsService.submitInvitesAndUpdate(invites, organizationId),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['organizationInvites', organizationId], refetchType: 'all' }),
        queryClient.invalidateQueries({ queryKey: ['numberOfInvitesLeft', organizationId] }),
      ]);
      notificationsStore.addToast('success', i18next.t('InvitesSentSuccessfully', { ns: 'studentsPage' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('SubmitInvitesError', { ns: 'studentsPage' }), 'error'),
  });
};
